import React from "react";
import {
  Phone,
  MapPin,
  Facebook,
  Instagram,
  MessageCircle,
  Clock,
} from "lucide-react";
import { Card } from "@/components/ui/card";

const Contact = () => {
  return (
    <main
      className="min-h-screen bg-[#F5F1E8] px-4 pb-20 pt-24 text-[#3E2723] md:px-6"
      data-testid="contact-page"
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-10 lg:flex-row">
        {/* LEFT */}
        <div className="space-y-5 lg:w-1/2">
          <p className="text-xs font-medium uppercase tracking-[0.18em] text-[#7ED956]">
            Contact
          </p>

          <h1 className="mt-2 font-['Fraunces',_serif] text-3xl md:text-4xl">
            Kom langs bij Aroma Cubana
          </h1>

          <p className="mt-3 text-sm text-[#3E2723]/80 md:text-base">
            Een vraag over het menu, reservaties of afhaal? Bel ons gerust of stuur
            een bericht via WhatsApp. We helpen je met plezier verder.
          </p>

          {/* INFO CARD */}
          <Card className="mt-4 space-y-4 rounded-2xl border border-[#3E2723]/10 bg-white/70 p-5 shadow-sm backdrop-blur-sm">
            {/* Adres */}
            <div className="flex items-start gap-3" data-testid="contact-adres">
              <MapPin className="mt-0.5 h-5 w-5 text-[#7ED956]" />
              <div>
                <p className="text-sm font-semibold">Aroma Cubana</p>
                <p className="text-sm">Sacramentstraat 9</p>
                <p className="text-sm">9100 Sint-Niklaas, België</p>
              </div>
            </div>

            {/* Telefoon */}
            <div className="flex items-center gap-3" data-testid="contact-telefoon">
              <Phone className="h-5 w-5 text-[#7ED956]" />
              <a
                href="tel:+32469435891"
                className="text-sm font-medium hover:underline"
              >
                +32 469 43 58 91
              </a>
            </div>

            {/* Openingsuren — DIRECT onder telefoon */}
            <div
              className="flex items-start gap-3"
              data-testid="contact-opening-hours"
            >
              <Clock className="mt-0.5 h-5 w-5 text-[#7ED956]" />
              <div>
                <p className="text-sm font-semibold">Openingsuren</p>
                <p className="text-sm">Di – Zo: 11:30 – 22:00</p>
                <p className="text-xs text-[#3E2723]/70">
                  Maandag gesloten
                </p>
              </div>
            </div>

            {/* BTW */}
            <p className="text-xs text-[#3E2723]/70">
              BTW: BE1013394038
            </p>
          </Card>

          {/* SOCIALS */}
          <div className="flex flex-wrap gap-3" data-testid="contact-social-links">
            <a
              href="https://www.facebook.com/p/Aroma-Cubana-61562797754081"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-[#3E2723]/10 bg-white/80 px-4 py-2 text-xs font-medium hover:border-[#7ED956]"
            >
              <Facebook className="h-4 w-4" /> Facebook
            </a>

            <a
              href="https://www.instagram.com/aromacubanabelgica"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-[#3E2723]/10 bg-white/80 px-4 py-2 text-xs font-medium hover:border-[#7ED956]"
            >
              <Instagram className="h-4 w-4" /> Instagram
            </a>

            <a
              href="https://wa.me/32469435891"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-[#7ED956] bg-[#7ED956]/10 px-4 py-2 text-xs font-medium hover:bg-[#7ED956]/15"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp
            </a>
          </div>
        </div>

        {/* RIGHT */}
        <div className="lg:w-1/2">
          <Card className="overflow-hidden rounded-3xl border border-[#3E2723]/10 bg-white/70 shadow-sm backdrop-blur-sm">
            <iframe
              src="https://www.google.com/maps?q=Aroma+Cubana+Sint-Niklaas&output=embed"
              width="100%"
              height="450"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Locatie Aroma Cubana"
            />
          </Card>
        </div>
      </div>
    </main>
  );
};

export default Contact;

